import React, { useEffect } from 'react';
import { Admin, Resource, CustomRoutes, Authenticated } from 'react-admin';
import authenProvider from './authenProvider';
import buildGraphQLProvider from 'ra-data-graphql-simple';
import { Route } from 'react-router-dom';
import CustomLayout from './components/layout/Layout';
import { genTokenApp } from './services/Login';
import TokenService from './services/TokenService';
import { appId } from './config/Config';
import theme from './components/layout/theme/Theme';
import './app.css';
import Login from './components/login/login';
import Loading from './components/layout/loading/Loading';
import { customeRoutesLayout, customRouteNoLayout } from './routes/Router';
import { client } from './config/Client';
import { resources } from './services/react-admin/Resources';
import { customQuery } from './services/react-admin/BuildQuery';
import { CssBaseline, ThemeProvider } from '@mui/material';

const App = () => {
  const [dataProvider, setDataProvider] = React.useState(null);
  const userRole = parseInt(localStorage.getItem('userRole'));
  React.useEffect(() => {
    buildGraphQLProvider({
      client,
      buildQuery: customQuery
    }).then((graphQlDataProvider) =>
      setDataProvider(() => graphQlDataProvider)
    );
  }, []);

  useEffect(() => {
    genTokenApp(appId).then((result) => {
      TokenService.updateLocalAppToken(result.token);
      TokenService.updateLocalAppID(result.app_id);
    });
  }, []);

  if (!dataProvider) {
    return <div>Loading</div>;
  }
  return (
    <React.StrictMode>
      <CssBaseline />
      <ThemeProvider theme={theme}>
        <Admin
          authProvider={authenProvider}
          loginPage={Login}
          title="Merchant Portal"
          dataProvider={dataProvider}
          layout={CustomLayout}
          theme={theme}
        >
          <CustomRoutes>
            {customeRoutesLayout.map((p, index) => {
              const Element = p.element;
              return <Route key={index} path={p.path} element={<Authenticated requireAuth><Element /></Authenticated>} />;
            })}
          </CustomRoutes>
          <CustomRoutes noLayout>
            {customRouteNoLayout.map((p, index) => {
              const Element = p.element;
              return <Route key={index} path={p.path} element={<Element />} />;
            })}
          </CustomRoutes>
          {resources.map((p, index) => {
            if (!(p.showWithRoles.includes(userRole) || p.isPublic)) return null;
            return (
              <Resource
                key={index}
                name={p.name}
                icon={p.icon}
                list={p.list}
                create={p.create}
                edit={p.edit}
              />
            );
          })}
        </Admin>
        <Loading />
      </ThemeProvider>
    </React.StrictMode>
  );
};

export default App;
